<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addShowDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
    append-to-body
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="name" label="名称:">
          <el-input type="text" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item required prop="isShow" label="是否显示在小程序:">
          <el-select v-model="form.isShow" placeholder="是否显示在小程序">
            <el-option
              v-for="item in isShowType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isShowPicture == true" label="展示图片">
          <el-upload
            action
            ref="fileUpload"
            :data="pictureType"
            :file-list="fileList"
            :on-exceed="handleExceed"
            name="picture"
            list-type="picture-card"
            :on-preview="handleAvatarPictureCardPreview"
            :on-remove="handleAvatarRemove"
            :before-upload="beforeAvatarUpload"
            :http-request="handleUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="avatarDialogVisible"
            size="tiny"
            append-to-body
          >
            <img width="100%" :src="dialogAvatarImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="cancle()">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { deleteImage } from "@/api/coach";
import {
  addActiontype,
  uploadPicture,
  deletePicture,
  editActiontype,
} from "@/api/show";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isShowPicture: false,
      isVisible: this.isShow,
      dialogAvatarImageUrl: "",
      avatarDialogVisible: false,
      fileList: [],
      isShowType: [
        { label: "否", value: 0 },
        { label: "是", value: 1 },
      ],
      form: {
        id: "",
        name: "",
        isShow: "",
      },
      pictureType: {
        pictureType: "show",
        actionId: "",
      },
      form_rules: {},
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
      isSame: true,
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
  },
  computed: {
    ...mapGetters(["addShowDialog"]),
  },
  created() {},
  mounted() {
    if (this.addShowDialog.type === "edit") {
      this.form = this.dialogRow;
      this.pictureType.actionId = this.form.id;
      this.isShowPicture = true;
      //更新图片列表
      if (this.form.picture !== "" && this.form.picture !== null) {
        this.form.pictures.forEach((item) => {
          console.log(item);
          let fileList = {
            name: "",
            url: item,
          };
          this.fileList.push(fileList);
        });
        console.log(this.fileList);
      }
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    handleUpload(data) {
      let file = data.file;
      let params = new FormData();
      params.append("picture", file);
      params.append("pictureType", "show");
      params.append("actionId", this.form.id);
      uploadPicture(params).then((res) => {
        console.log(res);
        if (res.data.code !== 200) {
          this.$refs.fileUpload.handleRemove(file);
        } else {
          let fileList = {
            name: "",
            url: res.data.data.url,
          };
          this.fileList.push(fileList);
        }
      });
    },
    beforeRemove(file, fileList) {
      console.log(file);
      const para = {
        actionId: this.form.id,
        pictureUrl: file.url,
      };
      this.$confirm("确认删除该图片吗?", "提示", {
        type: "warning",
      }).then(() => {
        deletePicture(para).then((res) => {
          console.log(res);
          if (res.data.code === 200) {
            return true;
          } else {
            return false;
          }
        });
      });
      return false;
    },
    cancle() {
      console.log("cancle");
      this.isVisible = false;
      this.$emit("getShowList");
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    //教练头像图片上传成功回调函数
    handleAvatarSuccess(res, file) {
      console.log(file.response);
      if (file.response.code == 200) {
        console.log(this.fileList);
        //更新图片列表
        let fileList = {
          name: "",
          url: file.response.data.url,
        };
        this.fileList.push(fileList);
      } else {
        this.$message({
          type: "warning",
          message: file.response.msg,
          duration: 3000,
        });
        this.$emit("getShowList");
      }
    },
    //上传图片大于上限的处理函数
    handleExceed() {
      this.$message({
        type: "info",
        message: "只能上传一张图片",
        duration: 6000,
      });
    },
    //删除图片的处理函数
    handleAvatarRemove(file, fileList) {
      console.log("filelist:", this.fileList);
      console.log("file:", file);
      let para = {
        url: file.url,
      };
      console.log(para);
      const para1 = {
        actionId: this.form.id,
        pictureUrl: file.url,
      };
      deletePicture(para1).then((res) => {
        console.log(res);
        deleteImage(para).then((res) => {
          console.log(res);

          // this.fileList = [];
          var fileListVar = [];
          this.fileList.forEach((item) => {
            if (item.uid !== file.uid) {
              fileListVar.push(item);
            }
          });
          this.fileList = fileListVar;
        });
      });

      this.$message({
        type: "warning",
        message: "已删除原有图片/已存在图片",
        duration: 3000,
      });
    },
    //图片预览的处理函数
    handleAvatarPictureCardPreview(file) {
      this.avatarDialogVisible = true;
      this.dialogAvatarImageUrl = file.url;
    },
    handleDetailsPictureCardPreview(file) {
      this.detailsDialogVisible = true;
    },
    //上传之前的格式验证函数
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!isLt2M) {
        console.log("上传头像图片大小不能超过 4MB!");
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      return isLt2M;
      // if (!isJPG) {
      //   console.log("上传头像图片只能是 JPG/PNG 格式!");
      //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      // }
      // return (isJPG || isJPG) && isLt2M;
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addShowDialog.type === "edit") {
            editActiontype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.isVisible = false;
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.name + ")展示栏目操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$emit("getShowList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addActiontype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增(" + this.form.name + ")展示栏目操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getShowList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
